<div class="dropdown" ngxClickElsewhere (clickElsewhere)="isDropDown = false" [ngClass]="{'disabled disabled--grayed': isDisabled}">
    <div class="dropdown__btn" (click)="onToggle()">
        <div *ngIf="!isZeroAllowed" class="mr-2">{{ f[parentControl].value || activeTitle || 'Izaberi' }}</div>
        <div *ngIf="isZeroAllowed" class="mr-2">{{ f[parentControl].value ?? activeTitle ?? 'Izaberi' }}</div>
        <div [class.dropdown__arrow]="isDropDown">
            <i class="fa fa-chevron-down"></i>
        </div>
    </div>
    <div class="dropdown__list" [class.dropdown__list--visible]="isDropDown" [formGroup]="parentForm">
        <label class="dropdown__item"
               *ngIf="showAll"
               (change)="isDropDown = false">
            <input class="selectgroup-input" type="radio" [formControlName]="parentControl" [value]="''">
            Prikaži sve
        </label>

        <label class="dropdown__item" *ngFor="let option of options; trackBy: trackByFunction"
               (change)="isDropDown = false">
            <input class="selectgroup-input" type="radio" [formControlName]="parentControl" [value]="option"
                   [class.is-invalid]="f[parentControl].errors && f[parentControl].errors.required"
            >{{ option }}
        </label>
    </div>
</div>
